export enum CmaStep {
  subject_property = "subject",
  ready_plan = "rp",
  comparables = "comps",
  adjustments = "adjustments",
  estimate = "estimate",
  hpo = "hpo",
}
